module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("税务信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.financeData,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.taxpayerRegistrationCode))]), _vm._v(" "), (_vm.snapshot.taxpayerRegistrationCode) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.taxpayerRegistrationCode))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "纳税人类型："
    }
  }, [(_vm.financeData.taxpayerType == 1) ? _c('span', [_vm._v("一般纳税人")]) : _vm._e(), _vm._v(" "), (_vm.financeData.taxpayerType == 2) ? _c('span', [_vm._v("小规模纳税人")]) : _vm._e(), _vm._v(" "), (_vm.snapshot.taxpayerType == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   一般纳税人")]) : _vm._e(), _vm._v(" "), (_vm.snapshot.taxpayerType == 2) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   小规模纳税人")]) : _vm._e()]), _vm._v(" "), (_vm.financeData.taxpayerType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "一般纳税人资格认定表：",
      "prop": "generalTaxpayerFile"
    }
  }, [_c('div', [_vm._l((_vm.financeData.generalTaxpayerFile.split(',')), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.snapshot.generalTaxpayerFile.split(',')), function(sgtFile) {
    return (sgtFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": sgtFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("货款支付账户")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行开户名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.accountName))]), _vm._v(" "), (_vm.snapshot.accountName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.accountName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行帐号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.accountNumber))]), _vm._v(" "), (_vm.snapshot.accountNumber) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.accountNumber))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.bankName))]), _vm._v(" "), (_vm.snapshot.bankName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.bankName))]) : _vm._e()]), _vm._v(" "), (_vm.financeData.registeredCountry != 1) ? _c('el-form-item', {
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.swiftCode))]), _vm._v(" "), (_vm.snapshot.swiftCode) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.swiftCode))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "省："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.province))]), _vm._v(" "), (_vm.snapshot.province) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.province))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.financeData.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "市："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.financeData.city))]), _vm._v(" "), (_vm.snapshot.city) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.city))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7513aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierapply/audit/financeInfo.vue
// module id = 533
// module chunks = 0